export const environmentCommons = {
  /** Mientras no exista el backend del dashboard, MSW sirve `/api/v1/dashboard/*` con datos de ejemplo sin necesidad de `?mock=true`. */
  mockDashboardApi: true,
  statusOptions: [
    { value: 'active', label: 'Activos' },
    { value: 'inactive', label: 'Inactivos' },
  ],
  channelOptions: [
    { value: 'EMAIL', label: 'Correo electrónico' },
    { value: 'SMS', label: 'SMS' },
    { value: 'WHATSAPP', label: 'WhatsApp' },
  ],
  roleOptions: [
    { value: 'CORPORATE_ADMIN', label: 'Administrador', description: 'Administrador' },
    { value: 'CORPORATE_SUPERVISOR', label: 'Supervisor', description: 'Supervisor' },
    { value: 'CORPORATE_AGENT', label: 'Gestor', description: 'Gestor' },
    { value: 'THIRDPARTY_AGENT', label: 'Gestor externo', description: 'Gestor externo' },
    { value: 'SYSTEM_ADMIN', label: 'Super Admin', description: 'Administrador del sistema con acceso total' },
  ]
};
